export class KeyCodesHelper {
    static default: Array<number> = [8, 9, 20, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46];
    static defaultNames: Array<string> = ["backspace", "tab", "caps lock", "page up", "page down", "end", "home", "left arrow", "up arrow", "right arrow", "down arrow", "insert", "delete"];
    static specialChars: Array<number> = [188, 189, 190, 222, 32];
    static numbers: Array<number> = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
    static alphabets: Array<number> = [32, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90];
    static dots: Array<number> = [110, 190];
}